module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAcCAMAAACj+uTiAAAAQlBMVEX9a2v/amr/MC7/f39HcEz/Li3+0mP/Ozr+YmH/REP9xEH+dXP+0oD9YTX/pUv9eT7/7KP+TEr/MzH+h3v/QT79V1eih3pfAAAABnRSTlP+c2YCAO08PgeTAAAA6klEQVR4XnXPV27EMAxFUcZDU7257H+reRSNERA4l/oRDwxYxJ8feunnQwx4JWJAmlEy8OQREXtKJ0qnMcQivn2y7VrfGuS+vXXPlTUg45+IQwhjzjyYJ+Lrmz/z6a8niHsKuWs5OAtyzFzuUevZFpDDSj0KvpLYky2Iay0qWSSrwAGuFOLRaq2tQQBwyaW1MgIk4AGtiUmMIvrjKmE2qkTpPUKqbSBWEYlVQcrflzaQQrssiJtzuVIhtTx3fenqwhpdeqasjnVZslpy2CCH8x1iWyoqrSBorWDmjng/XtuJt3fZiHnbX9r4FzDEHpn5T+IdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/small-red-bag.png
// module id = FofQ
// module chunks = 216